export default __webpack_public_path__ + "static/media/reminder.1c7af7b0.png";